<template>
    <footer class="footer">
        <div class="container row row-center">
            <p class="copyright">
                © {{ year }} ma-preadmission-front.com
            </p>
            <router-link 
                :to="'/mentions-legales'"
                class="footer-link"
            >
                Mentions légales
            </router-link>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'TheFooter',

        data(){
            return {
                year: new Date().getFullYear()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .footer {
        font-size: .875rem;
        padding: .75rem 0;
    }

    .copyright, .footer-link {
        padding: .25rem 0;
    }

    .footer-link {
        text-decoration: none;
        &::before {
            content: '|';
            margin: 0 .5rem;
        }
        &, &:visited {
            color: inherit;
        }
    }
</style>